import { render, staticRenderFns } from "./materials-cart.vue?vue&type=template&id=ecfeaa58"
import script from "./materials-cart.vue?vue&type=script&lang=js"
export * from "./materials-cart.vue?vue&type=script&lang=js"
import style0 from "./materials-cart.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports